import {drilldownComparisonLoader} from '../../../../util/dataLoader';
import {withTimeout} from '../../../../util/http/withTimeout';
import {IComparisonComponentAPIResponse} from './comparisonComponentSlice';

export const getComparison = (filters): Promise<IComparisonComponentAPIResponse> => {
  const controller = new AbortController();
  return withTimeout(
    drilldownComparisonLoader.get(filters, controller) as Promise<IComparisonComponentAPIResponse>,
    controller
  );
}
